module.exports = __webpack_public_path__ + "img/header.43e0f7fb.jpg";